// extracted by extract-css-chunks-webpack-plugin
module.exports = {"landingContainer":"landing-page__landingContainer__1-Rly","sideNavContainer":"landing-page__sideNavContainer__jDnQN"};